import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/auth/Truck3dOnroad.png")